import { httpCall } from "../../../Services/HttpService"
import { API_URL } from "../../../Utils/Urls"
export const forgotPassword = params => {
    return httpCall({
        url: API_URL.FORGOT_PASSWORD,
        method: "post",
        data: params
    }).then(response => {
        return response;
    });
};
export const resetPassword = params => {
  return httpCall({
      url: API_URL.CHANGE_PASSWORD,
      method: "post",
      data: params
  }).then(response => {
      return response;
  });
};


export const getArticleTypes = () => {
    return httpCall({
      url: API_URL.GET_ARTICLE_TYPES,
      method: "get"
    }).then(response => {
      return response;
    });
  };

  export const getLatestArtices= () => {
    return httpCall({
      url: API_URL.GET_LATEST_ARTICLES,
      method: "post"
    }).then(response => {
      return response;
    });
  };

  export const getAdds = () => {
    return httpCall({
      url: API_URL.GET_ADDS,
      method : "post"
    }).then(response => {
      return response;
    });
  };
  export const contactUs = (data) => {
    return httpCall({
      url: API_URL.CONTACT_US,
      method : "post",
      data: data

    }).then(response => {
      return response;
    });
  };
  export const mediaKit = (data) => {
    return httpCall({
      url: API_URL.MEDIA_KIT,
      method : "post",
      data: data
    }).then(response => {
      return response;
    });
  };
  export const partnerWithUs = (data) => {
    return httpCall({
      url: API_URL.PARTENER_WITHUS,
      method : "post",
      data: data
    }).then(response => {
      return response;
    });
  };


  
  export const getAuthors = () => {
    return httpCall({
      url: API_URL.GET_ARTICLE_AUTHORS,
      method: "get"
    }).then(response => {
      return response;
    });
  };
  

  
  export const subscribeNow = (data) => {
    return httpCall({
      url: API_URL.SUBSCRIBE_NOW,
      method: "post",
      data : data
    }).then(response => {
      return response;
    });
  };
  